// src/components/ProjectList.jsx
import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { useLanguage } from "../context/LanguageContext";
import { ThemeContext } from "../context/ThemeContext";
import { useThemeColors } from "../context/ThemeColorContext";
import { useStaticTexts } from "../context/StaticTextContext";
import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";

// Swiper imports
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const ProjectList = () => {
  const [projects, setProjects] = useState([]);
  const { lang } = useLanguage();
  const { darkMode } = useContext(ThemeContext);
  const {
    darkPrimary,
    darkSecondary,
    darkAccent,
    darkText,
    lightSecondary,
    lightText,
  } = useThemeColors();

  const staticTexts = useStaticTexts();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/projects/`)
      .then((res) => setProjects(res.data))
      .catch((err) => console.error(err));
  }, []);

  if (!staticTexts || Object.keys(staticTexts).length === 0) return null;
  if (projects.length === 0) return null;

  const {
    view_project_button,
    latest_projects_title,
    year_label,
    
  } = staticTexts;

  return (
    <section
      className="py-10 px-4 sm:px-10"
      style={{
        backgroundColor: darkMode ? darkPrimary : lightSecondary,
        color: darkMode ? darkText : lightText,
      }}
    >
      <h2 className="text-2xl font-bold mb-8 text-center">
        {latest_projects_title}
      </h2>

      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {projects.map((project, index) => (
          <motion.div
            key={project.id}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="rounded-xl shadow-lg overflow-hidden flex flex-col justify-between"
            style={{
              backgroundColor: darkMode ? darkSecondary : "#fff",
              color: darkMode ? darkText : lightText,
            }}
          >
            {/* اسلایدر تصاویر */}
            {project.images && project.images.length > 0 && (
              <Swiper
                modules={[Autoplay, Pagination]}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                pagination={{ clickable: true }}
                loop={true}
                className="w-full h-48"
              >
                {project.images.map((img) => (
                  <SwiperSlide key={img.id}>
                    <img
                      src={img.image}
                      alt={lang === "fa" ? img.alt_text_fa : img.alt_text_en}
                      className="w-full h-48 object-cover"
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}

            {/* اطلاعات پروژه */}
            <div className="p-4 flex flex-col flex-grow">
              <h3 className="text-lg font-semibold mb-2">
                {lang === "fa" ? project.title_fa : project.title_en}
              </h3>
              <p className="text-sm mb-4 line-clamp-3">
                {lang === "fa" ? project.description_fa : project.description_en}
              </p>

              <div className="text-xs mb-2 opacity-80">
                {project.technologies}
              </div>
              <div className="text-xs mb-2 opacity-80">
                {year_label}: {project.year}
              </div>

              {project.link && (
                <a
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-auto inline-flex items-center gap-2 text-sm font-medium px-4 py-2 rounded-lg transition w-fit"
                  style={{
                    backgroundColor: darkMode ? "#fff" : darkAccent,
                    color: darkMode ? darkPrimary : "#fff",
                  }}
                >
                  <ExternalLink size={16} />
                  {view_project_button}
                </a>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default ProjectList;
